import React from 'react';

import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { SUPER_USER } from '../../actionTypes/Users/UserActionType';
import MainNavDropdown from './MainNavDropdown';

const MainNav = () => {
  const { userDetails } = useSelector((state) => state.AppSession);

  return (
    <nav className="main-nav" aria-label="main navigation">
      <ul id="mainNav" role="presentation">
        {userDetails.userRole !== SUPER_USER && (
          <li>
            <Link to="/" className="anchor lsn-primary-color" aria-label="Landing Page">
              <i className="far fa-home"></i>
            </Link>
          </li>
        )}
        <li>
          <MainNavDropdown />
        </li>
      </ul>
    </nav>
  );
};

export default MainNav;
